<template>
  <div class="home-container">
    <el-row :gutter="20">
      <!-- 左侧：公告模块 -->
      <el-col :span="12">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">
              <i class="el-icon-bell"></i> 公告通知
            </span>
          </div>
          <div class="notice-list">
            <div v-if="noticeList.length === 0" class="empty-data">
              <i class="el-icon-document"></i>
              <p>暂无数据</p>
            </div>
            <div v-else>
              <div v-for="(item, index) in noticeList" :key="index" class="notice-item">
                <div class="notice-content">
                  <i class="el-icon-document-copy"></i>
                  <span class="notice-text">{{ item.title }}</span>
                </div>
                <span class="notice-time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧：用户信息和待办事项 -->
      <el-col :span="12">
        <!-- 用户信息模块 -->
        <el-card class="box-card user-info-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">
              <i class="el-icon-user"></i> 账号信息
            </span>
          </div>
          <div class="user-info">
            <div class="user-info-item">
              <span class="info-label">用户名称：</span>
              <span class="info-value">{{ userInfo.userName }}</span>
            </div>
            <div class="user-info-item">
              <span class="info-label">登录账号：</span>
              <span class="info-value">{{ userInfo.userAccount }}</span>
            </div>
            <div class="user-info-item">
              <span class="info-label">所属公司：</span>
              <span class="info-value">{{ userInfo.loginTenantName }}</span>
            </div>
          </div>
        </el-card>

        <!-- 待办事项模块 -->
        <el-card class="box-card todo-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">
              <i class="el-icon-s-order"></i> 待办事项
            </span>
          </div>
          <div class="todo-list">
            <div v-if="todoList.length === 0" class="empty-data">
              <i class="el-icon-document"></i>
              <p>暂无数据</p>
            </div>
            <div v-else>
              <div v-for="(item, index) in todoList" :key="index" class="todo-item">
                <div class="todo-content">
                  <i class="el-icon-s-claim"></i>
                  <span class="todo-text">{{ item.title }}</span>
                </div>
                <span class="todo-time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 公告列表 - 预留API调用位置
      noticeList: [
        // TODO: 替换为实际API调用
        // this.fetchNoticeList()
        { title: '测试数据1', time: '2024-01-01' },
        { title: '测试数据2', time: '2024-01-02' }
      ],
      // 待办事项列表 - 预留API调用位置
      todoList: [
        // TODO: 替换为实际API调用
        // this.fetchTodoList()
        { title: '测试数据1', time: '2024-01-01' },
        { title: '测试数据2', time: '2024-01-02' }
      ]
    };
  },
  computed: {
    // 从 store 获取用户信息
    userInfo () {
      return this.$store.state.loginUser;
    }
  },
  mounted () {
    // 页面加载时获取数据
    this.loadData();
  },
  methods: {
    // 加载页面数据
    loadData () {
      this.fetchNoticeList();
      this.fetchTodoList();
    },
    // 获取公告列表 - 预留API调用方法
    fetchNoticeList () {
      // TODO: 替换为实际API调用
      // 示例：
      // appjs.request('getNoticeList', {}).then((data) => {
      //   if (data.retCode === 'ok') {
      //     this.noticeList = data.additionalData.list;
      //   }
      // }).catch((error) => {
      //   console.error('获取公告列表失败：', error);
      // });

      // 暂时使用模拟数据
      this.noticeList = [
        { title: '测试数据1', time: '2024-01-01' },
        { title: '测试数据2', time: '2024-01-02' }
      ];
    },
    // 获取待办事项列表 - 预留API调用方法
    fetchTodoList () {
      // TODO: 替换为实际API调用
      // 示例：
      // appjs.request('getTodoList', {}).then((data) => {
      //   if (data.retCode === 'ok') {
      //     this.todoList = data.additionalData.list;
      //   }
      // }).catch((error) => {
      //   console.error('获取待办事项失败：', error);
      // });

      // 暂时使用模拟数据
      this.todoList = [
        { title: '测试数据1', time: '2024-01-01' },
        { title: '测试数据2', time: '2024-01-02' }
      ];
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: 100vh;
}

.el-row {
  display: flex;
  height: 100%;
}

.box-card {
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.card-title i {
  margin-right: 8px;
  color: #409eff;
}

/* 左侧公告卡片 */
.el-col:first-child .box-card {
  height: calc(100vh - 80px);
}

.el-col:first-child .box-card >>> .el-card__body {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

/* 公告列表样式 */
.notice-list {
  min-height: 100%;
}

.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-bottom: 1px solid #ebeef5;
  transition: all 0.3s;
  cursor: pointer;
}

.notice-item:last-child {
  border-bottom: none;
}

.notice-item:hover {
  background-color: #f5f7fa;
  transform: translateX(5px);
}

.notice-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.notice-content i {
  color: #409eff;
  margin-right: 10px;
  font-size: 16px;
}

.notice-text {
  color: #606266;
  font-size: 14px;
}

.notice-time {
  color: #909399;
  font-size: 12px;
  margin-left: 10px;
}

/* 用户信息样式 */
.user-info-card {
  margin-bottom: 20px;
}

.user-info {
  padding: 10px 0;
}

.user-info-item {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  border-bottom: 1px solid #ebeef5;
}

.user-info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: bold;
  color: #606266;
  min-width: 100px;
  font-size: 14px;
}

.info-value {
  color: #303133;
  font-size: 14px;
}

/* 待办事项样式 */
.todo-card {
  margin-bottom: 0;
  height: calc(100vh - 320px);
}

.todo-card >>> .el-card__body {
  height: calc(100vh - 420px);
  overflow-y: auto;
}

.todo-list {
  min-height: 100%;
}

.todo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-bottom: 1px solid #ebeef5;
  transition: all 0.3s;
  cursor: pointer;
}

.todo-item:last-child {
  border-bottom: none;
}

.todo-item:hover {
  background-color: #f5f7fa;
  transform: translateX(5px);
}

.todo-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.todo-content i {
  color: #e6a23c;
  margin-right: 10px;
  font-size: 16px;
}

.todo-text {
  color: #606266;
  font-size: 14px;
}

.todo-time {
  color: #909399;
  font-size: 12px;
  margin-left: 10px;
}

/* 空数据样式 */
.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 60px 0;
  color: #909399;
}

.empty-data i {
  font-size: 48px;
  margin-bottom: 15px;
  color: #c0c4cc;
}

.empty-data p {
  font-size: 14px;
  margin: 0;
}
</style>
